module.exports = __webpack_public_path__ + "static/media/cdphp.c55dac76.png";